export interface Weekday {
  value: number; // ISO 1..7
  label: string;
  short: string;
}

export const WEEKDAYS: Weekday[] = [
  { value: 1, label: "Monday", short: "Mon" },
  { value: 2, label: "Tuesday", short: "Tue" },
  { value: 3, label: "Wednesday", short: "Wed" },
  { value: 4, label: "Thursday", short: "Thu" },
  { value: 5, label: "Friday", short: "Fri" },
  { value: 6, label: "Saturday", short: "Sat" },
  { value: 7, label: "Sunday", short: "Sun" },
];

const SHORT_BY_VALUE = new Map(WEEKDAYS.map((w) => [w.value, w.short]));

/** Toggle a weekday in the list, returning a new sorted array. */
export function toggleWeekday(days: number[], day: number): number[] {
  const next = days.includes(day) ? days.filter((d) => d !== day) : [...days, day];
  return next.sort((a, b) => a - b);
}

/**
 * Human label for a set of weekdays: "" when empty, "Every day" for all 7,
 * otherwise consecutive runs of 3+ days collapse into a "Mon–Fri" range (en
 * dash); shorter runs (1-2 days) stay as individual shorts. Groups join with
 * ", " — e.g. [1,2,3,6,7] -> "Mon–Wed, Sat, Sun".
 */
export function formatWeekdays(days: number[]): string {
  if (days.length === 0) return "";
  if (days.length === 7) return "Every day";

  const sorted = [...days].sort((a, b) => a - b);
  const runs: number[][] = [];
  for (const day of sorted) {
    const current = runs[runs.length - 1];
    if (current && day === current[current.length - 1] + 1) {
      current.push(day);
    } else {
      runs.push([day]);
    }
  }

  const shortFor = (day: number) => SHORT_BY_VALUE.get(day) ?? String(day);
  return runs
    .map((run) =>
      run.length >= 3
        ? `${shortFor(run[0])}–${shortFor(run[run.length - 1])}`
        : run.map(shortFor).join(", "),
    )
    .join(", ");
}
